import script from "./HomePageTabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomePageTabs.vue?vue&type=script&lang=ts&setup=true"

import "./HomePageTabs.vue?vue&type=style&index=0&id=33838665&lang=css"

const __exports__ = script;

export default __exports__